import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { useState } from 'react'
import { Icon } from '~/components/icon'
import {
  AccordionContentVariants,
  AccordionIconVariants,
  AccordionRootVariants,
  AccordionTitleVariants,
  AccordionVariants,
} from './accordion.styles'
import type { AccordionContentProps, AccordionProps } from './accordion.types'

const DISPLAY_NAME = 'Accordion'

const AccordionRoot = ({
  title,
  disabled,
  children,
  ...otherProps
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <AccordionPrimitive.Root
      type="single"
      collapsible
      {...otherProps}
      className={AccordionRootVariants({ disabled })}
    >
      <AccordionPrimitive.Item value="item-1">
        <AccordionPrimitive.Header>
          <AccordionPrimitive.Trigger
            disabled={disabled}
            className={AccordionVariants({ open: isOpen, disabled })}
            onClick={() => setIsOpen(prevIsOpen => !prevIsOpen)}
            data-testid="accordion-main"
          >
            <span className={AccordionTitleVariants()}>{title}</span>
            <div className={AccordionIconVariants({ open: isOpen })}>
              <Icon
                symbol="rdicon-chevron-down"
                data-testid="input-select-icon"
                aria-hidden
                color={
                  disabled
                    ? 'colorTextNeutralDisabled'
                    : 'colorTextNeutralDefault'
                }
                size="small"
              />
            </div>
          </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
        <AccordionPrimitive.Content>
          <div
            className={`accordion-content ${AccordionContentVariants({})}`}
            data-testid="accordion-content"
            style={{ display: isOpen ? 'block' : 'none' }}
          >
            {children}
          </div>
        </AccordionPrimitive.Content>
      </AccordionPrimitive.Item>
    </AccordionPrimitive.Root>
  )
}

AccordionRoot.displayName = `${DISPLAY_NAME}Root`

const AccordionContent = (props: AccordionContentProps) => {
  const { children } = props

  return (
    <AccordionPrimitive.Content>
      <div className={`accordion-content ${AccordionContentVariants({})}`}>
        {children}
      </div>
    </AccordionPrimitive.Content>
  )
}

AccordionContent.displayName = `${DISPLAY_NAME}Content`

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Accordion = {
  Root: AccordionRoot,
  Content: AccordionContent,
}
